import List from "./List";
import Show from "./Show";

const orders = {
  list: List,
  show: Show,
};

export default orders;
